import { mapActions, mapState } from "pinia";
import useDynamicComponentBuilderStore from "%/stores/dynamic-component-builder-store";

const ContextualMenuMixinStaging = {
  data() {
    return {
      contextualMenuPosition: {
        top: 0,
        left: 0,
      },
    };
  },
  computed: {
    ...mapState(useDynamicComponentBuilderStore, [
      "showContextualMenuForIdInBuilder",
      "showContextualMenuForIdInLayers",
      "isDynamicAppComponent",
    ]),
    contextMenuFixedPositionStyle() {
      return {
        position: "fixed",
        zIndex: 30,
        ...this.contextualMenuPosition,
      };
    },
    showContextualMenu() {
      return this.showContextualMenuForIdInBuilder === this.identifier && !this.breakpoint;
    },
  },
  methods: {
    ...mapActions(useDynamicComponentBuilderStore, [
      "setShowContextualMenuForIdInBuilder",
      "setShowContextualMenuForIdInLayers",
      "isDeletable",
      "isEditable",
      "isDuplicatable",
      "canWrap",
      "canCreateCustomComponent",
    ]),
    openContextualMenuForBuilder(event) {
      if (!this.editMode || !event.target) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      const internalIsDeletable = this.isDeletable(this.identifier, this.configuration);
      const internalIsEditable = this.isEditable(this.identifier, this.configuration);
      const internalIsDuplicatable = this.isDuplicatable(this.identifier, this.configuration);
      const internalCanWrap = this.canWrap(this.identifier, this.configuration);
      const internalCanCreateCustomComponent = this.canCreateCustomComponent(this.identifier, this.configuration);
      const internalCanCopy = !!this.elementConfig;
      const internalCanPaste = !!this.elementConfig;

      const showBasedOnLockOptions = internalIsEditable || internalIsDeletable || internalIsDuplicatable ||
          internalCanWrap || internalCanCreateCustomComponent;

      if (showBasedOnLockOptions) {
        let clientY = event.clientY;
        // each true value is 40px - height of contextual menu item
        let trueVariables = [
          internalIsEditable,
          internalIsDeletable,
          internalIsDuplicatable,
          internalCanWrap,
          internalCanCreateCustomComponent,
          internalCanCopy,
          internalCanPaste,
          true,
        ].filter(Boolean).length;
        const bottomOfWindow = window.innerHeight - event.clientY;
        if (bottomOfWindow < trueVariables * 40) {
          const offset = (trueVariables - 1) * 40;
          this.contextualMenuPosition = {
            top: clientY - offset + "px",
            left: event.clientX + "px",
          };
        } else {
          this.contextualMenuPosition = {
            top: clientY + "px",
            left: event.clientX + "px",
          };
        }

        this.setShowContextualMenuForIdInLayers(null);
        this.setShowContextualMenuForIdInBuilder(this.identifier);
      }
    },
  },
};

export { ContextualMenuMixinStaging };
